import { cm, textRect, page, textLineRun, textLine, circularMedium, circularBlack, circularBook } from "./Declarations";
import { ItemRecord, backsideTable } from "./CommonLayout";

const circBook = { id: 1, font: circularBook };
const circMedium = { id: 3, font: circularMedium };
const circBlack = { id: 2, font: circularBlack };

export const fonts = [circBook, circMedium, circBlack];

export const pageLayout = page(
    textRect({ left: '297.638', baseline: "12cm", height: "3cm", font: circBlack, fontsize: 70, align: "center" }, "TILBOÐ"),
    textRect({ left: "297.638", baseline: cm(10.8), verticalShiftPerExtraLine: cm(0.35), height: "3cm", font: circMedium, fontsize: 18, align: "center" }, '{description}'),
    textRect({ left: "297.638", baseline: "9.6cm", height: "3cm", font: circMedium, fontsize: 13.4, align: "center" }, "AFSLÁTTUR"),
    textRect({ left: "297.638", baseline: "6.9cm", height: "3cm", font: circBlack, fontsize: 95.9, align: "center" }, '{discount}'),
    textRect({ left: "297.638", baseline: "5.9cm", height: "3cm", font: circMedium, fontsize: 15.7, align: "center" }, "TILBOÐSVERÐ kr."),
    textRect({ left: "297.638", baseline: "4.3cm", height: "3cm", font: circBlack, fontsize: 52.2, align: "center" }, '{discountPrice}'),
    
    textLine({ left: "297.638", baseline: "3.35cm", height: "3cm", align: "center", autoscalefont: true}, [
        textLineRun({ font: circMedium, fontsize: 15.7 }, 'Verð áður kr. '),
        textLineRun({ font: circMedium, fontsize: 15.7, strikeout: true}, ' {originalPrice} ')
    ]),
    
    textRect({ left: "297.638", baseline: "2.25cm", height: "3cm", font: circBlack, fontsize: 15, align: "center" }, "HVORKI SKILA- NÉ SKIPTIRÉTTUR"),
    
    ...backsideTable(circBook)
);

export function layout(records: ItemRecord[]) {
    return {
        records,
        pageLayout,
        fonts
    };
}
